import SCTable from "./Table";
export default SCTable;